<div class="PGSurveyAnswers">
    <div class="container-fluid">
        <div class="row">
            @for (question of answers.questions; track question; let i = $index) {
                <div class="col-12">
                    <label class="mb-2">
                        <b>{{formatQuestionText(question.text)}}</b>
                        @if (question.required) {
                            <small class="ms-1 {{ isQuestionUnanswered(question) ? 'text-danger' : 'text-muted'}}">
                                <i class="fa-regular fa-asterisk fa-sm"></i>
                            </small>
                        }
                    </label>
                </div>
                <div class="col-12 mb-3">
                    @if (question.type == 'string') {
                        <input type="text" class="form-control" [(ngModel)]="question.answer">
                    }
                    @if (question.type == 'boolean') {
                        <div class="form-check">
                            <input class="form-check-input" type="radio" value="true" id="{{randomId}}_{{i}}_radio_true" name="{{randomId}}_{{i}}_radio" [(ngModel)]="question.answer">
                            <label class="form-check-label ps-2" for="{{randomId}}_{{i}}_radio_true">
                                {{ 'pg-survey-editor.answer-boolean-true' | locTranslate }}
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" value="false" id="{{randomId}}_{{i}}_radio_false" name="{{randomId}}_{{i}}_radio" [(ngModel)]="question.answer">
                            <label class="form-check-label ps-2" for="{{randomId}}_{{i}}_radio_false">
                                {{ 'pg-survey-editor.answer-boolean-false' | locTranslate }}
                            </label>
                        </div>
                    }
                </div>
            }
        </div>
        <div class="row border-top pt-2">
            <div class="col">
                <button class="btn btn-primary float-end" [disabled]="isSubmitDisabled()" (click)="surveyAnswered.emit(answers)">{{ 'pg-survey-answers.button-confirm' | locTranslate }}</button>
            </div>
        </div>
    </div>
</div>
